export default __webpack_public_path__ + "static/media/myResume.d5e21d9b.png";